"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _time = _interopRequireDefault(require("@spothero/utils/time"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Select = _interopRequireDefault(require("../Select/Select"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TimePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimePicker, _Component);

  function TimePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      selectedTime: _this.props.selectedTime
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSelectChange", function (_ref) {
      var value = _ref.value;

      _this.setState({
        selectedTime: value
      });
    });
    var step = props.step,
        disableBefore = props.disableBefore,
        disableAfter = props.disableAfter;
    var dayStart = (0, _moment.default)().startOf('day');
    var timesParams = {
      step: step
    };

    if (disableBefore) {
      timesParams.ignoreBefore = (0, _moment.default)(disableBefore, 'hh:mm A').diff(dayStart, 'minutes');
    }

    if (disableAfter) {
      timesParams.ignoreAfter = (0, _moment.default)(disableAfter, 'hh:mm A').diff(dayStart, 'minutes');
    }

    _this._times = _time.default.getTimes(timesParams).map(function (_ref2) {
      var formatted = _ref2.formatted;
      return {
        value: formatted,
        label: formatted
      };
    });
    return _this;
  }

  (0, _createClass2.default)(TimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onChange = this.props.onChange;
      var selectedTime = this.state.selectedTime;

      if (selectedTime !== prevState.selectedTime && onChange) {
        onChange(selectedTime);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          useIcon = _this$props.useIcon,
          name = _this$props.name,
          disabled = _this$props.disabled;
      var selectedTime = this.state.selectedTime;
      var classes = (0, _classnames.default)('TimePicker', {
        'TimePicker-with-icon': useIcon
      }, className);
      return _react.default.createElement("div", {
        className: classes
      }, label, _react.default.createElement(_Select.default, {
        ref: function ref(node) {
          _this2._select = node;
        },
        name: name,
        defaultValue: selectedTime,
        onChange: this._onSelectChange,
        items: this._times,
        disabled: disabled,
        icon: useIcon ? _react.default.createElement(_Icon.default, {
          name: "clock"
        }) : null,
        placeholder: placeholder
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",

    /**
     * Getter for the select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */
    get: function get() {
      return this._select.node;
    }
  }]);
  return TimePicker;
}(_react.Component);

exports.default = TimePicker;
(0, _defineProperty2.default)(TimePicker, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,

  /** Whether to show the clock icon in the input field. */
  useIcon: _propTypes.default.bool,

  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,

  /** The placeholder text to show in the input before a selection is made. */
  placeholder: _propTypes.default.string,

  /** A string in the format of 'hh:mm A' representing the time which should be selected. */
  selectedTime: _propTypes.default.string,

  /** The multiplier with which to create selectable times in the dropdown (in minutes). */
  step: _propTypes.default.number,

  /** A string in the format 'hh:mm A' representing the time where times before it should be disabled in the selector. */
  disableBefore: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times after it should be disabled in the selector. */
  disableAfter: _propTypes.default.string,

  /** Whether the component is disabled. */
  disabled: _propTypes.default.bool,

  /**
   * Function to execute when the selected time changes.
   *
   * @param {String} selectedTime - The selected time in the format 'hh:mm A'.
   */
  onChange: _propTypes.default.func
});
(0, _defineProperty2.default)(TimePicker, "defaultProps", {
  useIcon: true,
  step: 30
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TimePicker, "TimePicker", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/TimePicker.jsx");
  leaveModule(module);
})();

;